/**
 * SchemaStatusBadge — shared Preset vs Custom (published) pill used in schema
 * pickers (upload dropdown, provider form schema multi-select).
 *
 * Extracted so Add/Edit Provider and SchemaSelectDropdown stay visually consistent.
 */

import { cn } from "@/lib/utils";

export type SchemaStatusBadgeStatus = "preset" | "published";

interface SchemaStatusBadgeProps {
  status?: SchemaStatusBadgeStatus | string | null;
  className?: string;
}

/**
 * Renders a small Preset (green) or Custom (cyan) badge from schema status.
 * Unknown / missing status renders nothing.
 */
export function SchemaStatusBadge({ status, className }: SchemaStatusBadgeProps) {
  if (status !== "preset" && status !== "published") return null;
  const isPreset = status === "preset";
  return (
    <span
      className={cn(
        "rounded-full border px-2 py-0.5 text-[10px] font-medium leading-none",
        isPreset ? "border-green-500 text-green-700" : "border-cyan-500 text-cyan-700",
        className
      )}
    >
      {isPreset ? "Preset" : "Custom"}
    </span>
  );
}
